import { baseQuery } from '../baseQuery';

type PostTechnicianRecurringAvailabilityPayload = {
  technicianId: number;
  start_date: string;
  end_date: string;
  start_time: number;
  end_time: number;
  days: string[];
  setting: 'N' | 'C';
};

export const postTechnicianRecurringAvailability = async (payload: PostTechnicianRecurringAvailabilityPayload) => {
  const { technicianId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${technicianId}/recurring-availabilities`, {
    type: 'POST',
    body: {
      ...rest,
    },
  });

  return data;
};
